import { render, staticRenderFns } from "./ImportUser.vue?vue&type=template&id=f4655672&scoped=true"
import script from "./ImportUser.vue?vue&type=script&lang=js"
export * from "./ImportUser.vue?vue&type=script&lang=js"
import style0 from "./ImportUser.vue?vue&type=style&index=0&id=f4655672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4655672",
  null
  
)

export default component.exports